import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const modelApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getModels: builder.query({
      query: filters => {
        const qs = Object.keys(filters || {}).reduce((acc, k) => {
          acc.set(k, filters[k]);
          return acc;
        }, new URLSearchParams());
        return `llm_model/?${qs}`;
      },
      providesTags: ['LLMModel'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetModelsQuery
} = modelApi;

